import { ExerciceDto } from "../../dto/GenApi.iNotPaie.Dto/ExerciceDto";
import { ParametreModuleDto } from "../../dto/GenApi.iNotPaie.Dto/ParametreModuleDto";
import { UtilisateurConnecteDto } from "../../dto/GenApi.iNotPaie.Dto/UtilisateurConnecteDto";
import EventConstants, { RoleConstants } from "../Controls/EventConstants";
import { ModalEnqueteSatisfactionOptions } from "../modalComponents/modalEnqueteSatisfaction/modalEnqueteSatisfaction";
import { EventBus } from "../Controls/EventBus";
import { ParametresInstance } from "../Controls/Parameters";
import { ServicesFactoryInstance } from "../Controls/ServicesFactory";
import { ParametrageModuleEnum } from "../../dto/GenApi.iNotPaie.Dto/ParametrageModuleEnum";
import { ParametrageModuleIdEnum } from "../../dto/GenApi.iNotPaie.Dto/ParametrageModuleIdEnum";

export class ServiceEnqueteDeSatisfaction {
    private lastExerciceClosed!: ExerciceDto;
    private userPst?: UtilisateurConnecteDto;
    private modePst?: ParametreModuleDto;

    public enqueteDeSatisfaction(callbackYes?: () => void): void {
        this.userPst = ParametresInstance.utilisateurCourant;
        this.getModePst(() => {
            if (this.modePst !== undefined && this.modePst.StrData === "1") {
                if (this.isUserPst()) {
                    this.getLastExerciceClosed(() => {
                        if (this.lastExerciceClosed !== null && this.lastExerciceClosed !== undefined && this.lastExerciceClosed.Note === null) {
                            this.openModal(callbackYes);
                        } else if (callbackYes != undefined)
                            callbackYes();
                    });
                } else if (callbackYes != undefined) {
                    callbackYes();
                }
            }
        });
    }

    public getLastExerciceClosed(callback?: () => void): ExerciceDto {
        ServicesFactoryInstance.ExercicesService.getDernierExerciceCloture(data => {
            this.lastExerciceClosed = data;
            if (callback !== undefined)
                callback();
        });
        return this.lastExerciceClosed;
    }

    private getModePst(callback: () => void): void {
        ServicesFactoryInstance.ParametrageModuleService.getParametrageModule(ParametrageModuleEnum.PST, ParametrageModuleIdEnum.PST_ACTIVE, data => {
            this.modePst = data;
            callback();
        });
    }

    private isUserPst(): boolean {
        if (this.userPst !== undefined
            && this.userPst.Roles !== undefined
            && this.userPst.Roles.indexOf(RoleConstants.UtilisateurPST) !== -1)
            return true;
        return false;
    }

    private openModal(callbackYes?: () => void): void {
        var modalOptions: ModalEnqueteSatisfactionOptions = new ModalEnqueteSatisfactionOptions({
            message: "Avez-vous été satisfait du traitement de vos payes du mois passé?",
            callbackYes: callbackYes,
        });
        EventBus.$emit(EventConstants.MODAL_ENQUETE_SATISFACTION, modalOptions);
    }
}

export const ServiceEnqueteDeSatisfactionInstance: ServiceEnqueteDeSatisfaction = new ServiceEnqueteDeSatisfaction();



// WEBPACK FOOTER //
// ./src/components/enqueteDeSatisfaction/service.ts